/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

'use client';

import { getFirebaseApp } from './firebaseApp';

/** Matches the native `KEY_IS_ALL_STAR`; sent as "true"/"false". */
export const KEY_IS_ALL_STAR = 'isAllStar';

/**
 * Mirrors the native `FirebaseService.setUserProperty(name, value)`. Populates
 * GA4 only — the web RC fetch does not send these, so target an Audience.
 */
export const setAnalyticsUserProperty = async (
  name: string,
  value: string,
): Promise<void> => {
  const app = await getFirebaseApp();
  if (!app) return;

  try {
    const { getAnalytics, isSupported, setUserProperties } = await import(
      'firebase/analytics'
    );
    if (!(await isSupported())) return;
    setUserProperties(getAnalytics(app), { [name]: value });
  } catch {
    // Reporting only.
  }
};

/** Several at once; empty values skipped, matching native `pushUserProfile`. */
export const setAnalyticsUserProperties = async (
  properties: Record<string, string>,
): Promise<void> => {
  await Promise.all(
    Object.entries(properties)
      .filter(([, value]) => value !== '')
      .map(([name, value]) => setAnalyticsUserProperty(name, value)),
  );
};
